
    <fieldmagic-dialog
      label="Please Verify"
      [instance]="self"
    >
      <ng-template fieldmagicDialogButtonsTmp></ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div
          class="d-flex justify-content-center align-items-center"
          style="height: 90px"
        >
          <re-captcha
            (resolved)="onComplete($event)"
          >
          </re-captcha>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  